// extracted by mini-css-extract-plugin
export default {"container":"Empty_container__LzkkF","icon":"Empty_icon__JDbT2","title":"Empty_title__coO7d","message":"Empty_message__4PIIL","button":"Empty_button__Eogwk"};